export enum EModalServicesAmplitude {
  TRIAL_START_VIEW = 'trialstart_view', //Cuando el usuario ve el modal que le indica que esta en trial
  TRIAL_START_ACTION = 'trialstart_action' //cuando el usuario da click en el modal que le indica que esta en trial
}
